import {match} from 'ts-pattern';

import type {CustomerMessageResponseBody} from '@dms/api/core';

import {
  ASSISTANT_INTEREST_TEXT_MAX_CHARACTERS,
  type BusinessCaseTimelineEvent,
  type BusinessCaseTimelineEventKind,
} from '@prompt-bridge/shared/ai-assistant-core';

const toMessageKind = (channel: CustomerMessageResponseBody['channel']) =>
  match(channel)
    .returnType<BusinessCaseTimelineEventKind>()
    .with('email', () => 'email')
    .with('sms', () => 'sms')
    .with('whatsapp', () => 'message')
    .with('call', () => 'call')
    .exhaustive();

type BusinessCaseTimelineMessage = Pick<
  CustomerMessageResponseBody,
  'channel' | 'createdAt' | 'direction' | 'id'
>;

export const toBusinessCaseMessageTimelineEvent = (
  message: BusinessCaseTimelineMessage
): BusinessCaseTimelineEvent => ({
  id: message.id.slice(0, ASSISTANT_INTEREST_TEXT_MAX_CHARACTERS),
  occurredAt: message.createdAt,
  direction: message.direction === 'INCOMING' ? 'inbound' : 'outbound',
  kind: toMessageKind(message.channel),
});
